import React from 'react';

import { CardSkeleton } from '../../../Skeleton';
import useTreeMapData from './useTreeMapData';
import TreeMapView from './TreeMapView';

// eslint-disable-next-line
const TreeMapContent = React.memo(
  ({
    chartDefinition,
    chartRef,
    useSmallNoDataMessage,
  }: {
    chartDefinition: V5ChartDefinition;
    chartRef: React.MutableRefObject<any>;
    useSmallNoDataMessage: boolean;
  }) => {
    const { options, isNoData } = useTreeMapData({ chartDefinition, chartRef });

    if (!options) {
      return <CardSkeleton />;
    }

    return (
      <TreeMapView
        options={options}
        chartRef={chartRef}
        isNoData={isNoData}
        useSmallNoDataMessage={useSmallNoDataMessage}
      />
    );
  },
);

export default TreeMapContent;
